module.exports = __webpack_public_path__ + "img/耦合线2.de1df233.svg";